// extracted by mini-css-extract-plugin
module.exports = {"search__item":"SearchItem_search__item__BHBre"};